import React from "react";

export function LoadingState({message = "Loading…"}) {
    return <div className="loading">{message}</div>;
}

export function ErrorState({error}) {
    return <div className="error">{error?.message || "Request failed"}</div>;
}
